import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { adminMe, adminIsLoggedIn } from "@/store/auth";

import AppNotifications from "@/components/AppNotifications";
import AppLayout from "@/components/AppLayout";
import AuthLayout from "@/components/AuthLayout";

import Login from "./Login";
import Dashboard from "./Dashboard";
import Plans from "./Plans";
import Alerts from "./Alerts";
import Agencies from "./Agencies";
const Admin: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isLoggedIn, me } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!isLoggedIn) {
      dispatch(adminIsLoggedIn());
    }
    if (isLoggedIn && (!me?.id || !me?.isAdmin)) {
      dispatch(adminMe());
    }
  }, [isLoggedIn, me, dispatch]);

  const layoutComponent = () => {
    return isLoggedIn ? (
      <AppLayout>
        <Routes>
          <Route path="/plans" element={<Plans />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/agencies" element={<Agencies />} />
          <Route path="/*" element={<Dashboard />} />
        </Routes>
      </AppLayout>
    ) : (
      <AuthLayout>
        <Routes>
          <Route path="*" element={<Login />} />
        </Routes>
      </AuthLayout>
    );
  };

  return (
    <>
      {layoutComponent()}
      <AppNotifications />
    </>
  );
};

export default Admin;